<template>
    <div>
        <template v-if="isPartOfForm">
            <div class="form-group">
                <label :class="{'inline-label': isInline}">Sales rep</label>
                <select style="min-width: 150px" class="form-control" name="salesman" :value="value" @input="onChange">
                    <option value="" >...</option>
                    <option v-for="salesman in salesmenList" :value="salesman.id">{{salesman.name}}</option>
                </select>
            </div>
        </template>
        <div v-else class="col-md-4 col-lg-2">
            <h2 class="h5 h-aside">Filters</h2>
            <form method="GET" class="flex">
            <div class="form-group">
                <label for="frm-state">Sales rep</label>
                <select style="min-width: 200px" class="form-control" name="salesman" :value="value">
                    <option value="" >...</option>
                    <option v-for="salesman in salesmenList" :value="salesman.id">{{salesman.name}}</option>
                </select>
            </div>
                <div class="form-group" style="padding: 23px 0px 0 10px">
                    <button class="btn btn-info">Apply</button>
                </div>
            </form>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'salesmen-filter',
        props: {
            salesmenList: Array,
            value: String,
            isPartOfForm: {
                type: Boolean,
                default: false
            },
            isInline: {
                type: Boolean,
                default: false
            }
        },
        data() {
            return {
            };
        },
        computed: {

        },
        methods: {
            onChange(evt){
                this.$emit('input', evt.target.value);
            }
        },
    }
</script>

<style>
    .inline-label{
        font-weight: normal;
        margin-bottom: 0;
    }
</style>
